import React, { useEffect, useState } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Card } from "@/components/ui/card";
import { Table, TableHeader, TableHead, TableRow, TableBody, TableCell } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DataToolbar, StatusBadge } from "@/components/data/Common";
import { api, API } from "@/lib/api";
import { Download } from "lucide-react";

const MODULES = ["production", "workorders", "breakdowns", "inventory", "safety", "documents", "quality"];

export default function AuditTrail() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [mod, setMod] = useState("all");

  const load = () => api.get("/audit", { params: mod !== "all" ? { module: mod } : {} }).then((r) => setList(r.data));
  useEffect(() => { load(); }, [mod]);

  const filt = list.filter((a) => !q || `${a.user_email} ${a.user_name} ${a.action} ${a.entity_id || ""} ${a.module}`.toLowerCase().includes(q.toLowerCase()));

  const exportExcel = async () => {
    const t = localStorage.getItem("neipl_token");
    const r = await fetch(`${API}/audit/export${mod !== "all" ? `?module=${mod}` : ""}`, { headers: { Authorization: `Bearer ${t}` } });
    const b = await r.blob(); const u = URL.createObjectURL(b);
    const a = document.createElement("a"); a.href = u; a.download = "audit_log.xlsx"; a.click();
  };

  return (
    <AppLayout title="Audit Trail" subtitle="All create / edit / delete activity across modules">
      <DataToolbar search={q} setSearch={setQ} onExport={exportExcel} searchTestId="audit-search-input"
        filters={
          <Select value={mod} onValueChange={setMod}>
            <SelectTrigger className="w-44" data-testid="audit-module-filter"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All modules</SelectItem>
              {MODULES.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
            </SelectContent>
          </Select>
        }
      />
      <Card className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Timestamp</TableHead><TableHead>User</TableHead><TableHead>Role</TableHead>
              <TableHead>Module</TableHead><TableHead>Action</TableHead>
              <TableHead>Entity</TableHead><TableHead>Previous</TableHead><TableHead>Updated</TableHead>
              <TableHead>Remarks</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filt.map((a) => (
              <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                <TableCell className="font-mono text-xs">{a.created_at?.slice(0, 19).replace("T", " ")}</TableCell>
                <TableCell className="text-sm"><div className="font-medium">{a.user_name}</div><div className="text-xs text-slate-400">{a.user_email}</div></TableCell>
                <TableCell><StatusBadge status={a.user_role} /></TableCell>
                <TableCell className="text-xs"><StatusBadge status="active" /> <span className="ml-1">{a.module}</span></TableCell>
                <TableCell><StatusBadge status={a.action === "delete" ? "critical" : a.action === "update" ? "medium" : "operational"} /></TableCell>
                <TableCell className="font-mono text-xs text-slate-400">{a.entity_id?.slice(0, 8) || "—"}</TableCell>
                <TableCell className="font-mono text-xs max-w-[160px] truncate text-slate-500">{a.previous ? JSON.stringify(a.previous) : "—"}</TableCell>
                <TableCell className="font-mono text-xs max-w-[200px] truncate text-slate-700">{a.updated ? JSON.stringify(a.updated) : "—"}</TableCell>
                <TableCell className="text-xs text-slate-500">{a.remarks || "—"}</TableCell>
              </TableRow>
            ))}
            {!filt.length && <TableRow><TableCell colSpan={9} className="text-center py-12 text-slate-400">No audit records</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </AppLayout>
  );
}
